<div class="row margin-top-8">
    <div class="col-12 pr-4">
        <button class="float-right border-0 color-white background-none outline-0 box-shadow-none font-size-16"
            (click)="closeOverlay()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </button>
    </div>
</div>
<div class="row mt-6 headings p-0">
    <div class="col p-2">
        <div class="row">
            <div class="col">
                <label for="" class="h4">Contact Us</label>
            </div>
        </div>
        <hr class="color-white px-2">
        <div class="row">
            <div class="col">
                <label for="" class="h5">Customer Support</label>
                <div>
                    <label for="" class="cursor" (click)="onCallClick('01548400173')"><i class="fas fa-phone mr-2"></i>
                        01548400173</label>
                </div>
                <div>
                    <label for=""><i class="fas fa-envelope mr-2"></i> customersupport@olarme.com</label>
                </div>
                <!-- <div>
                    <label for="" class="cursor" (click)="onChatStartClick()">
                        <i class="fas fa-comment-dots mr-2"></i>
                         Chat with us
                    </label>
                </div> -->
            </div>
        </div>
        <hr class="color-white px-2">
        <div class="row">
            <div class="col">
                <label for="" class="h5">Sales and Finance</label>
                <div>
                    <label for="" class="cursor" (click)="onCallClick('0392130100')"><i class="fas fa-phone mr-2"></i>
                        0392130100</label>
                </div>
                <div>
                    <label for=""><i class="fas fa-envelope mr-2"></i> sales@olarme.com,finance@olarme.com </label>
                </div>
                <!-- <div>
                    <label for="" class="cursor" (click)="onChatStartClick()">
                        <i class="fas fa-comment-dots mr-2"></i>
                         Chat with us
                    </label>
                </div> -->
            </div>
        </div>
        <hr class="color-white px-2">
    </div>
</div>

<div class="row" style="margin-top: 20%;">
    <div class="col-12 text-center">
        <button class="background-none outline-0 box-shadow-none listyourrestaurantbtn border-radius-4"
            (click)="listYourRestaurantClick()">
            <i class="fas fa-list pr-1"></i>
            List Your Restaurant
        </button>
    </div>
</div>

<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<div class="row mt-6 headings p-0">
    <div class="col p-2">
        <div class="row">
            <div class="col text-center">
                <label for="" class="h5">Chat with us</label>
            </div>
        </div>
    </div>
</div>

<ng-template #chatbox>
    <div class="modal-body rounded" style="background-color:white;">
        <div class="row no-gutters">
            <div class="col">
                <i class="fas fa-times fa-lg cursor close" (click)="onCloseChatClick()"></i>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <iframe [src]="chatUrl" class="trackingWindow" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</ng-template>